import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/nedbank-pay/auth-callback',
    name: 'nedbankPayAuthCallback',
    component: () => import('../views/NedbankAuthCallback.vue'),
  },
  {
    path: '/',
    name: 'main',
    component: () => import('../views/Main.vue'),
    children: [
      {
        path: '/',
        name: 'banks',
        component: () => import('../views/Banks.vue'),
      },
      {
        path: '/progress',
        name: 'progress',
        component: () => import('../views/Progress.vue'),
        children: [
          {
            path: '/',
            name: 'progressLoading',
          },
          {
            path: '/login',
            name: 'login',
            component: () => import('../views/Login.vue'),
          },
          {
            path: '/accounts',
            name: 'accounts',
            component: () => import('../views/Accounts.vue'),
          },
          {
            path: '/otp',
            name: 'otp',
            component: () => import('../views/Otp.vue'),
          },
          {
            path: '/qr',
            name: 'qr',
            component: () => import('../views/QrScan.vue'),
          },
          {
            path: '/partial-password',
            name: 'partialPassword',
            component: () => import('../views/PartialPassword.vue'),
          },
          {
            path: '/card-pin',
            name: 'cardPin',
            component: () => import('../views/CardPin.vue'),
          },
          {
            path: '/bank-authentication',
            name: 'countdownTimer',
            component: () => import('../views/BankAuthTimer.vue'),
          },
          {
            path: '/finalise-nedbank-payment',
            name: 'nedbankFinalisePayment',
            component: () => import('../views/NedbankFinalisePayment.vue'),
          },
          {
            path: '/select-absa-account',
            name: 'absaAccounts',
            component: () => import('../views/AbsaAccounts.vue'),
          },
          {
            path: '/absa-auth',
            name: 'absaAuthScreen',
            component: () => import('../views/AbsaAuthScreen.vue'),
          },
        ],
      },
      {
        path: '/error',
        name: 'error',
        component: () => import('../views/InternalError.vue'),
      },
      {
        path: '/completed',
        name: 'completed',
        component: () => import('../views/TransactionCompleted.vue'),
      },
      {
        path: '/cancelled',
        name: 'cancelled',
        component: () => import('../views/TransactionError.vue'),
      },
    ],
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes,
})

export default router
